async function checkVideoRecorder(check){
    console.log(`${check.title} Check Started`);

    let reply = { isPassed: false, details: "Not Working!" };

    // Try modern ClientTransport first (CEF scheme / WebSocket)
    if (window.ClientTransport && window.ClientTransport.initialize) {
        try {
            var transport = await window.ClientTransport.initialize();
            if (transport) {
                reply.isPassed = true;
                reply.details = "Detected (ClientTransport).";
                reply.details = `${check.title}: ${reply.details}`;
                return reply;
            }
        } catch (e) {
            console.warn("checkVideoRecorder: ClientTransport.initialize failed", e);
        }
    }

    // Fallback: browser recording via RelayMultistreamRecorder
    if (window.BrowserRecordingClient && window.RelayMultistreamRecorder && window.RelayMultistreamRecorder.initFallback) {
        reply.isPassed = true;
        reply.details = "Detected (BrowserRecording fallback).";
        reply.details = `${check.title}: ${reply.details}`;
        return reply;
    }

    console.error("No recording transport available (no ClientTransport, no BrowserRecording fallback)!");
    reply.details = "No recording transport available!";

    reply.details = `${check.title}: ${reply.details}`;
    return reply;
}

export default checkVideoRecorder;